import { render } from "./Carousel1.vue?vue&type=template&id=4696277c"
import script from "./Carousel1.vue?vue&type=script&lang=js"
export * from "./Carousel1.vue?vue&type=script&lang=js"

import "./Carousel1.vue?vue&type=style&index=0&id=4696277c&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__